import { useEditMode } from '../../focus/useIsEditMode';
import { EditableQuestion } from '../EditableQuestion';
import { useQuizFormField } from '../hook/useQuizFormField';
import { OXContent } from './OXContent';
import { OXEdit } from './OXEdit';
export const EditableOX = () => {
  const [answer, updateAnswer] = useQuizFormField({
    field: 'oxData.answer'
  });
  const {
    isEditMode
  } = useEditMode();
  return <div className="flex flex-col gap-xs pb-xs" onClick={e => e.stopPropagation()} data-sentry-component="EditableOX" data-sentry-source-file="EditableOX.tsx">
      <EditableQuestion data-sentry-element="EditableQuestion" data-sentry-source-file="EditableOX.tsx" />
      <OXEdit answer={answer} onChange={updateAnswer} isVisible={isEditMode} data-sentry-element="OXEdit" data-sentry-source-file="EditableOX.tsx" />
      <OXContent answer={answer} isVisible={!isEditMode} data-sentry-element="OXContent" data-sentry-source-file="EditableOX.tsx" />
    </div>;
};